import type { SVGProps } from 'react';

export type IconName =
  | 'arrow-right' | 'calendar' | 'clock' | 'instagram' | 'share' | 'volume' | 'volume-off'
  | 'check' | 'chevron-down' | 'copy' | 'search' | 'qr' | 'phone' | 'lock' | 'users'
  | 'chart' | 'logout' | 'plus' | 'edit' | 'camera' | 'close' | 'external' | 'warning'
  | 'user' | 'spark' | 'refresh' | 'filter' | 'mail' | 'shield' | 'menu';

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  title?: string;
}

const paths: Record<IconName, JSX.Element> = {
  'arrow-right': <path d="M5 12h14m-6-6 6 6-6 6" />,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  instagram: <><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><path d="M17.5 6.5h.01" /></>,
  share: <><circle cx="18" cy="5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="19" r="2.5" /><path d="m8.2 10.8 7.6-4.6m0 11.6-7.6-4.6" /></>,
  volume: <><path d="M4 10v4h4l5 4V6L8 10H4Z" /><path d="M16 9.5a4 4 0 0 1 0 5m2.5-7.5a7 7 0 0 1 0 10" /></>,
  'volume-off': <><path d="M4 10v4h4l5 4V6L8 10H4Z" /><path d="m16 10 5 5m0-5-5 5" /></>,
  check: <path d="m5 12 4.2 4.2L19 6.5" />,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  copy: <><rect x="8" y="8" width="11" height="11" rx="2" /><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" /></>,
  search: <><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4 4" /></>,
  qr: <><rect x="4" y="4" width="6" height="6" rx="1" /><rect x="14" y="4" width="6" height="6" rx="1" /><rect x="4" y="14" width="6" height="6" rx="1" /><path d="M14 14h2v2h-2zm4 0h2v4h-2zm-4 4h4v2h-4z" /></>,
  phone: <path d="M5.5 4.7 8 4l1.7 4.2-1.8 1.5a15.2 15.2 0 0 0 6.4 6.4l1.5-1.8L20 16l-.7 2.5a2.3 2.3 0 0 1-2.5 1.6C10 19.1 4.9 14 3.9 7.2A2.3 2.3 0 0 1 5.5 4.7Z" />,
  lock: <><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 4v3" /></>,
  users: <><path d="M16 20v-1.5a4.5 4.5 0 0 0-4.5-4.5h-4A4.5 4.5 0 0 0 3 18.5V20" /><circle cx="9.5" cy="7" r="3.5" /><path d="M16 4.2a3.5 3.5 0 0 1 0 6.6m2 3.7a4.5 4.5 0 0 1 3 4.2V20" /></>,
  chart: <><path d="M4 19V5m0 14h17" /><path d="m7 15 4-4 3 2 5-7" /></>,
  logout: <><path d="M10 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5" /><path d="m14 16 4-4-4-4m4 4H8" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  edit: <><path d="m4 20 4.1-1 10.2-10.2a2.1 2.1 0 0 0-3-3L5.1 15.9 4 20Z" /><path d="m13.8 7.3 3 3" /></>,
  camera: <><path d="M4 8h3l1.5-2h7L17 8h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z" /><circle cx="12" cy="14" r="3.5" /></>,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  external: <><path d="M14 4h6v6m0-6-9 9" /><path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" /></>,
  warning: <><path d="M12 3 2.8 19a1.4 1.4 0 0 0 1.2 2h16a1.4 1.4 0 0 0 1.2-2L12 3Z" /><path d="M12 9v4m0 4h.01" /></>,
  user: <><circle cx="12" cy="8" r="3.5" /><path d="M5 21v-1a7 7 0 0 1 14 0v1" /></>,
  spark: <path d="m12 2 1.6 6.4L20 10l-6.4 1.6L12 18l-1.6-6.4L4 10l6.4-1.6L12 2Zm7 13 0.7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15Z" />,
  refresh: <><path d="M20 11a8 8 0 0 0-14.7-4.3L3 9" /><path d="M3 4v5h5m-4 4a8 8 0 0 0 14.7 4.3L21 15" /><path d="M21 20v-5h-5" /></>,
  filter: <path d="M4 5h16l-6.4 7.1V18l-3.2 1v-6.9L4 5Z" />,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /></>,
  shield: <path d="M12 3 4.5 6v5c0 4.6 3.2 8.8 7.5 10 4.3-1.2 7.5-5.4 7.5-10V6L12 3Zm-3 9 2 2 4-4" />,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
};

export function Icon({ name, title, ...props }: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {paths[name]}
    </svg>
  );
}
